// avstemming-assets-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'avce.common.amount': 'Importe',
  'avce.common.date': 'Fecha',
  'avce.common.type': 'Tipo',
  'avce.common.account': 'Cuenta',
  'avce.common.status': 'Estado',
  'avce.common.difference': 'Diferencia',
  'avce.common.none': 'Ninguno',
  'avce.common.close': 'Cerrar',
  'avce.common.assess': 'Evaluar',
  'avce.common.viewAssessment': 'Ver evaluación',
  'avce.common.requestDocs': 'Solicitar documentación al cliente',
  'avce.common.incomplete': 'Incompleto',
  'avce.common.notFetched': 'La aplicación no lo obtiene',
  'avce.common.details': 'Detalles',
  'avce.common.warning': 'Aviso',
  'avce.common.voucher': 'Justificante',
  'avce.common.reset': 'Restablecer',
  'avce.common.all': 'Todos',
  'avce.common.ofCount': '{done} de {total}',
  'avce.common.documentation': 'Documentación',
  'avce.common.depreciation': 'Amortización',
  'avce.common.depreciations': 'Amortizaciones',
  'avce.common.reviewNeeded': 'Requiere evaluación',
  'avce.common.notRelevant': 'No relevante',
  'avce.common.matches': 'Cuadra',
  'avce.derived.possibleCapitalization': 'Las posibles compras activables se han evaluado',
  'avce.derived.directPosting': 'Las contabilizaciones directas en cuentas de activo fijo se han evaluado',
  'avce.derived.depreciationDiff': 'Las diferencias de amortización se han tratado',
  'avce.derived.noDepreciation': 'Los activos sin amortización calculada se han tratado',
  'avce.derived.possibleDisposal': 'Las posibles bajas se han examinado',
  'avce.derived.registeredDisposal': 'Las bajas registradas se han comprobado',
  'avce.derived.gainLoss': 'Las ganancias y pérdidas por baja se han comprobado',
  'avce.derived.proceedsNotBooked': 'Las contraprestaciones no contabilizadas se han resuelto',
  'avce.derived.missingDocs': 'La documentación faltante se ha resuelto',
  'avce.derived.fullyDepreciated': 'Los activos totalmente amortizados se han evaluado',
  'avce.derived.negativeValue': 'Los valores contables negativos se han tratado',
  'avce.checklist.noPoints': 'No hay puntos de control definidos para los activos en este periodo.',
  'avce.checklist.title': 'Lista de verificación profesional',
  'avce.checklist.titleReadOnly': 'Lista de verificación profesional (del ejecutor, solo lectura)',
  'avce.checklist.scope': 'Los puntos se aplican a toda el área de activos. La marca se guarda en todas las cuentas del área.',
  'avce.checklist.groupItems': 'Partidas que requieren tratamiento',
  'avce.checklist.handledOf': '{done} de {total} tratadas',
  'avce.checklist.notApplicable': 'No aplica este periodo',
  'avce.checklist.followsAssessments': 'Se deduce de las evaluaciones',
  'avce.checklist.groupAssessments': 'Evaluaciones profesionales generales',
  'avce.checklist.groupRelevance': 'Evaluación general de relevancia',
  'avce.checklist.relevanceNote': 'Aspectos que la contabilidad no ve. «No relevante» también es una respuesta: no hay nada que evaluar si el cliente no tiene arrendamientos, ni activos en poder de terceros, ni ha constituido garantías.',
  'avce.checklist.groupReady': 'Preparación para el cierre',
  'avce.checklist.findingsHandled': '{total} hallazgos de control tratados: {done} de {total}',
  'avce.checklist.manualProgress': '{done} de {total} puntos de control manuales completados',
  'avce.checklist.manualProgressBy': 'Realiza {name} · {done} de {total} puntos de control manuales completados',
  'avce.blocker.findings': '{count} hallazgos de control no están completamente evaluados',
  'avce.blocker.accounts': '{count} cuentas de activo fijo difieren del registro',
  'avce.blocker.docs': 'Falta {count} documentación obligatoria',
  'avce.blocker.manualOne': 'Queda {count} punto de control manual',
  'avce.blocker.manualMany': 'Quedan {count} puntos de control manuales',
  'avce.conclusion.title': 'Conclusión y aprobación',
  'avce.conclusion.label': 'Conclusión',
  'avce.conclusion.placeholder': '¿Qué muestra la revisión de los activos de este periodo?',
  'avce.conclusion.savedAs': 'Se guarda como justificación del punto de control «{label}».',
  'avce.conclusion.remainingRisk': 'Riesgo restante',
  'avce.conclusion.noRisk': 'No queda nada que impida enviar el área a revisión. La conciliación compara dos fuentes propias de la empresa; la existencia física, la titularidad y el deterioro de valor se han confirmado manualmente, no por la contabilidad.',
  'avce.conclusion.followUp': 'Seguimiento del próximo periodo',
  'avce.conclusion.noFollowUp': 'Ninguna evaluación está marcada para seguimiento en el próximo periodo.',
  'avce.conclusion.followedUp': 'En seguimiento',
  'avce.conclusion.measure': 'Medida: {measure}',
  'avce.conclusion.noMeasure': 'Sin medida registrada',
  'avce.conclusion.deadline': ' · Plazo {date}',
  'avce.conclusion.openAssessment': 'Abrir evaluación',
  'avce.conclusion.sendToReview': 'Enviar el área a revisión',
  'avce.conclusion.oneLeft': 'Queda una cosa antes de poder enviar el área.',
  'avce.conclusion.manyLeft': 'Quedan {count} cosas antes de poder enviar el área.',
  'avce.drawer.note.capitalization': 'Evalúa: ¿la adquisición tiene una vida útil que obligue a activarla, es un solo activo o varios, y el transporte y la instalación forman parte del coste de adquisición?',
  'avce.drawer.note.depreciation': 'Evalúa: ¿es correcto el grupo de saldo, está la amortización contabilizada en el ejercicio correcto y hay indicios de deterioro de valor más allá de la amortización ordinaria?',
  'avce.drawer.note.documentation': 'Evalúa: ¿puede documentarse el coste de adquisición y qué se obtiene donde falta el justificante?',
  'avce.drawer.note.disposal': 'Evalúa: ¿el activo ha salido realmente del negocio, está contabilizada la contraprestación y se trata correctamente en el resultado la ganancia o pérdida (contraprestación menos valor contable)? A efectos fiscales, la contraprestación reduce en cambio el grupo de saldo, y ambas cosas no deben mezclarse.',
  'avce.drawer.note.directPosting': 'Evalúa: ¿debe el asiento estar en la cuenta de activo fijo y, en ese caso, debe entrar también en el registro de activos fijos para amortizarse?',
  'avce.drawer.note.lifetime': 'Evalúa: ¿el activo sigue existiendo, se usa, es razonable el valor residual y debería darse de baja y eliminarse del registro?',
  'avce.drawer.assetInRegister': ' · Activo en el registro',
  'avce.drawer.assessment': 'Evaluación',
  'avce.drawer.reason': 'Justificación profesional',
  'avce.drawer.reasonRequired': 'Justificación profesional (obligatoria)',
  'avce.drawer.reasonPlaceholder': '¿De qué trata el asunto y en qué se basa la evaluación?',
  'avce.drawer.measure': 'Medida',
  'avce.drawer.measurePlaceholder': 'P. ej. Registrar el activo, corregir el justificante o pedir documentación al cliente',
  'avce.drawer.followUpDeadline': 'Plazo de seguimiento',
  'avce.drawer.followUpNext': 'Seguimiento en el próximo periodo',
  'avce.drawer.needsReason': 'Esta evaluación requiere una justificación.',
  'avce.drawer.markDone': 'Marcar como evaluado',
  'avce.sources.title': 'Fuentes de datos',
  'avce.sources.oneIncomplete': '{count} fuente no está completa para el periodo.',
  'avce.sources.manyIncomplete': '{count} fuentes no están completas para el periodo.',
  'avce.sources.allPresent': 'Las fuentes que lee la conciliación están disponibles para el periodo.',
  'avce.sources.colSource': 'Fuente',
  'avce.sources.complete': 'Completo',
  'avce.main.title': 'Conciliación principal automática',
  'avce.main.noAccounts': 'Ninguna cuenta de activo fijo que comparar',
  'avce.main.differenceOpen': 'La diferencia debe tratarse',
  'avce.main.matches': 'El registro de activos fijos y el libro mayor cuadran en conjunto',
  'avce.main.ledgerValue': 'Valor contable en el libro mayor',
  'avce.main.registerValue': 'Valor contable en el registro de activos fijos',
  'avce.main.preliminaryDifference': 'Diferencia provisional',
  'avce.main.notBookedDepreciation': 'Amortización calculada aún no contabilizada',
  'avce.main.explainedItems': 'Partidas explicadas en la conciliación',
  'avce.main.unexplainedDifference': 'Diferencia sin explicar',
  'avce.main.comparedOn': 'Comparado en {accounts}.',
  'avce.main.explanation': 'El valor contable en el libro mayor son las cuentas de activo fijo menos la amortización acumulada. La conciliación de saldos compara dos fuentes propias de la empresa; la existencia, la clasificación, la amortización y la documentación de los activos se determinan mediante los controles de abajo, no porque las dos cifras coincidan.',
  'avce.main.cost': 'Coste de adquisición',
  'avce.main.accumulated': 'Amortización acumulada',
  'avce.main.bookValueRegister': 'Valor contable en el registro',
  'avce.main.activeAssets': 'Activos en uso',
  'avce.main.yearDepreciation': 'Amortización calculada {year}',
  'avce.main.additionsYtd': 'Altas en lo que va de {year}',
  'avce.main.disposalsPeriod': 'Bajas en el periodo',
  'avce.main.itemsNeedAssessment': 'Asuntos que requieren evaluación',
  'avce.main.openRegister': 'Abrir el registro de activos fijos',
  'avce.main.seeDepreciation': 'Ver las amortizaciones',
  'avce.main.seeControlAccounts': 'Ver las cuentas de control',
  'avce.accounts.notCompared': 'No comparado',
  'avce.accounts.title': 'Cuentas de control en el libro mayor',
  'avce.accounts.none': 'No existe ninguna cuenta de activo fijo en este periodo.',
  'avce.accounts.hint': 'Haz clic en una cuenta con activos para ver qué activos tiene el registro en ella.',
  'avce.accounts.colAccount': 'Cuenta de control',
  'avce.accounts.colOpening': 'Saldo inicial',
  'avce.accounts.colAdditions': 'Altas',
  'avce.accounts.colDisposals': 'Bajas',
  'avce.accounts.colClosing': 'Saldo final',
  'avce.accounts.colRegisterValue': 'Valor en registro',
  'avce.accounts.accumulatedNote': 'Amortización acumulada. La amortización acumulada del registro incluye el importe calculado del ejercicio, que solo se contabiliza en el cierre anual, por lo que la cuenta no se compara directamente.',
  'avce.accounts.costNote': 'Se compara con el coste de adquisición del registro',
  'avce.accounts.sumCost': 'Total del coste de adquisición en el registro de activos fijos',
  'avce.accounts.ledgerBalance': 'Saldo del libro mayor, cuenta {code}',
  'avce.accounts.unexplained': 'Diferencia sin explicar: consulta las adquisiciones y las contabilizaciones directas',
  'avce.tile.possibleCapitalization': 'Posibles compras activables',
  'avce.tile.depreciationDiff': 'Diferencias de amortización',
  'avce.tile.missingDocs': 'Falta documentación',
  'avce.tile.noDepreciation': 'Sin amortización calculada',
  'avce.tile.fullyDepreciated': 'Activos totalmente amortizados',
  'avce.tile.possibleDisposals': 'Posibles bajas sin registrar',
  'avce.tile.directPostings': 'Contabilizaciones directas en cuentas de activo fijo',
  'avce.tile.negativeValues': 'Valores contables negativos',
  'avce.controlCard.title': 'Tarjeta de control',
  'avce.controlCard.progress': '{checks} controles automáticos ejecutados · evaluados manualmente {done} de {total}',
  'avce.controlCard.registerVsLedger': 'Registro de activos fijos frente al libro mayor',
  'avce.controlCard.accountsCompared': '{count} cuentas comparadas',
  'avce.controlCard.activeFilter': 'Filtro activo: {label} · {count} partidas',
  'avce.checks.title': 'Controles automáticos',
  'avce.checks.note': 'Los controles no marcan nada en la lista de verificación profesional. Indican qué debería haber revisado quien la marca. El deterioro de valor, la titularidad y la existencia física no se pueden leer de la contabilidad y por eso figuran entre los puntos manuales.',
  'avce.checks.colCheck': 'Control',
  'avce.checks.colRun': 'Ejecución',
  'avce.checks.colFindings': 'Hallazgos',
  'avce.checks.run': 'Ejecutado',
  'avce.checks.found': '{count} hallazgos',
  'avce.checks.noFindings': 'Sin hallazgos',
  'avce.depr.notBookedYet': 'Aún no contabilizado',
  'avce.assetStatus.active': 'En uso',
  'avce.assetStatus.writtenOff': 'Totalmente amortizado',
  'avce.assetStatus.sold': 'Vendido',
  'avce.register.title': 'Registro de activos fijos',
  'avce.register.intro': 'El registro es propio de la aplicación. La amortización contabilizada sigue la vida útil y el valor residual de cada activo; el saldo fiscal se calcula por separado para cada grupo.',
  'avce.register.note': 'Plumme calcula el importe a partir del plan, pero no elige la vida útil, el valor residual ni si existe deterioro de valor. Las decisiones profesionales deben documentarse, y la falta de un plan o de la evaluación anual del deterioro de valor queda como desviación.',
  'avce.register.colAsset': 'Activo',
  'avce.register.colGroup': 'Grupo de saldo',
  'avce.register.colAcquired': 'Adquirido',
  'avce.register.colLife': 'Vida útil',
  'avce.register.colDepreciation': 'Amortización {year}',
  'avce.register.colAccumulated': 'Amort. acum.',
  'avce.register.colBookValue': 'Valor contable',
  'avce.register.years': '{years} años',
  'avce.register.empty': 'Ningún activo coincide con los filtros.',
  'avce.acq.title': 'Adquisiciones y control de activación',
  'avce.acq.kpiAnalyzed': 'Compras analizadas',
  'avce.acq.kpiOverThreshold': 'Por encima del umbral',
  'avce.acq.kpiCapitalized': 'Activado en el periodo',
  'avce.acq.kpiDirect': 'Contabilizado directamente en cuenta de activo fijo',
  'avce.acq.noThreshold': 'El umbral de activación es una norma fiscal noruega. El país contable es {country} y Plumme no tiene un umbral equivalente con el que comprobar aquí.',
  'avce.acq.threshold': 'El umbral es {amount} con al menos {years} años de vida útil, y se aplica a UN solo activo, no al total de la factura. Es una señal de control: Plumme no decide que una compra deba activarse, y una compra menor puede ser activable si la vida útil es lo bastante larga.',
  'avce.acq.colSupplier': 'Proveedor',
  'avce.acq.colDescription': 'Descripción',
  'avce.acq.colDeductibleVat': 'IVA deducible',
  'avce.acq.colTreatment': 'Tratamiento',
  'avce.acq.capitalized': 'Activado',
  'avce.acq.expensed': 'Contabilizado como gasto',
  'avce.acq.empty': 'Ninguna compra del periodo es lo bastante grande para compararse con el umbral.',
  'avce.depr.kpiBookedYtd': 'Contabilizado en lo que va del año',
  'avce.depr.kpiDeviatingGroups': 'Grupos de saldo con desviaciones',
  'avce.depr.kpiWithoutPlan': 'Activos sin amortización calculada',
  'avce.depr.note': 'La amortización se contabiliza en el cierre anual, no mensualmente. Por eso una diferencia al principio del año normalmente solo significa que el año no ha terminado: es un punto de control, no una desviación en sí misma.',
  'avce.depr.colRate': 'Tasa',
  'avce.depr.colAssets': 'Activos',
  'avce.depr.colExpenseAccount': 'Cuenta de gastos',
  'avce.depr.colCalculated': 'Amortización calculada',
  'avce.depr.colBooked': 'Amortización contabilizada',
  'avce.depr.empty': 'No hay grupos de saldo con activos ni amortización contabilizada.',
  'avce.disposals.title': 'Ventas y retiros',
  'avce.disposals.kpiRegistered': 'Bajas registradas',
  'avce.disposals.kpiUnregistered': 'Posibles bajas no registradas',
  'avce.disposals.kpiGainReview': 'Ganancia/pérdida por comprobar',
  'avce.disposals.kpiNoVoucher': 'Bajas registradas sin justificante',
  'avce.disposals.registerProceeds': 'Contraprestación en el registro de activos fijos',
  'avce.disposals.bookedProceeds': 'Importe de venta contabilizado en {accounts}',
  'avce.disposals.computedGain': 'Ganancia/pérdida calculada (registro)',
  'avce.disposals.bookedNet': 'Neto contabilizado en las cuentas de baja',
  'avce.disposals.note': 'La ganancia es la contraprestación menos el valor contable en el momento de la baja. Si la amortización no está contabilizada, la contrapartida soporta todo el coste de adquisición y el neto contabilizado resulta inferior a la ganancia calculada; la diferencia es entonces la misma amortización que aparece como línea propia en la conciliación principal. A efectos fiscales, la baja se trata en el grupo de saldo, no como ganancia.',
  'avce.disposals.colAssetOrPosting': 'Activo o asiento',
  'avce.disposals.colProceeds': 'Contraprestación',
  'avce.disposals.colBookValueAtDisposal': 'Valor contable en la baja',
  'avce.disposals.colGain': 'Ganancia/pérdida calculada',
  'avce.disposals.voucherNo': 'Justificante {number}',
  'avce.disposals.registeredInPeriod': 'Registrado en el periodo',
  'avce.disposals.empty': 'No hay bajas ni abonos en las cuentas de activo fijo en el periodo.',
  'avce.flag.possibleCapitalization': 'Posible compra activable',
  'avce.flag.directPosting': 'Contabilización directa en cuenta de activo fijo',
  'avce.flag.depreciationDiff': 'Diferencia de amortización',
  'avce.flag.noDepreciation': 'Sin amortización calculada',
  'avce.flag.missingBookPlan': 'Falta el plan de amortización contable',
  'avce.flag.missingImpairment': 'Falta la evaluación anual del deterioro de valor',
  'avce.flag.fullyDepreciated': 'Totalmente amortizado: sigue en el registro',
  'avce.flag.possibleDisposal': 'Posible baja no registrada',
  'avce.flag.disposalRegistered': 'Baja registrada en el periodo',
  'avce.flag.negativeValue': 'Valor contable negativo',
  'avce.flag.gainReview': 'La ganancia/pérdida requiere comprobación',
  'avce.flag.proceedsNotBooked': 'Contraprestación no contabilizada',
  'avce.assess.notAssessed': 'Sin evaluar',
  'avce.assess.noCorrection': 'No se necesita corrección',
  'avce.assess.capitalize': 'Debe activarse en el registro de activos fijos',
  'avce.assess.correctlyExpensed': 'Correctamente contabilizado como gasto',
  'avce.assess.correctAccount': 'Se corrige: se contabiliza en la cuenta correcta',
  'avce.assess.depreciationCorrected': 'Se corrige la amortización',
  'avce.assess.depreciationAccepted': 'Desviación de amortización aceptada',
  'avce.assess.registerDisposal': 'La baja se registra en el registro de activos fijos',
  'avce.assess.notDisposal': 'No es una baja',
  'avce.assess.lifetimeConfirmed': 'Sigue en uso: vida útil evaluada',
  'avce.assess.retire': 'Se retira: se elimina del registro',
  'avce.assess.gainConfirmed': 'Ganancia/pérdida comprobada y correcta',
  'avce.assess.bookProceeds': 'La contraprestación debe contabilizarse',
  'avce.assess.impairmentAssessed': 'Deterioro de valor evaluado',
  'avce.assess.awaitingDocs': 'A la espera de documentación',
  'avce.assess.awaitingClient': 'A la espera del cliente',
  'avce.type.capitalization': 'Activación',
  'avce.type.disposal': 'Baja',
  'avce.type.directPosting': 'Contabilización directa',
  'avce.type.lifetime': 'Vida útil y uso',
  'avce.quick.done': 'Evaluado',
  'avce.quick.newInPeriod': 'Nuevo en el periodo',
  'avce.quick.noDocs': 'Sin documentación',
  'avce.quick.disposalInPeriod': 'Baja en el periodo',
  'avce.flags.more': '+{count} más',
  'avce.items.intro': 'Las partidas se recopilan del registro de activos fijos, las adquisiciones, las amortizaciones, las bajas y los asientos de las cuentas de activo fijo. La evaluación se guarda en la cuenta de conciliación y la lee el revisor.',
  'avce.items.clearFilters': 'Restablecer filtros',
  'avce.items.colReference': 'Referencia',
  'avce.items.colAssessmentStatus': 'Estado de la evaluación',
  'avce.items.empty': 'Ninguna partida coincide con los filtros.',
  'avce.docs.colBasis': 'Base',
  'avce.docs.inPlace': 'Disponible',
  'avce.docs.attached': 'Documentación adjunta',
  'avce.docs.empty': 'No se han subido documentos en el área de activos para este periodo.',
  'avce.docs.emptyWithUpload': 'No se han subido documentos en el área de activos para este periodo. Usa la pestaña de documentos del panel derecho para adjuntarlos.',
  'avce.page.noAccount': 'El área de activos no tiene cuenta de conciliación en este periodo.',
  'avce.nav.overview': 'Resumen',
  'avce.nav.countDifference': '{count} diferencia',
  'avce.nav.fixedAssets': 'Activos fijos',
  'avce.nav.countRegistered': '{count} registrados',
  'avce.nav.acquisitions': 'Adquisiciones',
  'avce.nav.countToAssess': '{count} por evaluar',
  'avce.nav.countPurchases': '{count} compras',
  'avce.nav.countFindings': '{count} hallazgos',
  'avce.nav.controlAccounts': 'Cuentas de control',
  'avce.nav.countMatching': '{matching}/{total} cuadran',
  'avce.nav.deviationsActions': 'Desviaciones y medidas',
  'avce.nav.countMissing': 'Faltan {count}',
  'avce.nav.controlApproval': 'Control y aprobación',
  'avce.page.assets': 'Activos',
  'avce.page.hintOpen': '{count} partidas con aviso no están completamente evaluadas.',
  'avce.page.hintDone': 'Todas las partidas con aviso están evaluadas.',
  'avce.page.title': 'Activos: registro de activos fijos, libro mayor y amortizaciones',
  'avce.page.responsible': ' · Responsable {name}',
  'avce.page.threshold': ' · Umbral de activación {amount}',
  'avce.page.itemsNeedAssessment': '{count} partidas requieren evaluación',
  'avce.page.noOpenItems': 'Ninguna partida abierta',
  'avce.page.intro': 'La conciliación compara el registro de activos fijos con el libro mayor y busca lo que nunca llegó al registro.',
  'avce.page.noItemsFlagged': 'Ninguna partida está señalada para este periodo.',
  'avce.page.itemsFlagged': '{total} partidas están señaladas y {open} de ellas aún requieren una evaluación.',
  'avce.page.method': 'Método de amortización',
  'avce.page.methodValue': 'Amortización por saldo decreciente por grupo de saldo',
  'avce.page.hasFixedAssets': 'La empresa tiene activos fijos',
  'avce.page.noneInRegister': 'Ninguno en el registro',
  'avce.page.yes': 'Sí',
  'avce.page.country': 'País contable',
  'avce.page.readThrough': 'Datos leídos hasta',
  'avce.page.noExternalBalance': 'Los activos no tienen saldo externo. Tanto el registro de activos fijos como el libro mayor son fuentes propias de la empresa, y un activo que nunca se registró falta en ambos. Por eso la existencia física, la titularidad, las garantías y el deterioro de valor se confirman manualmente en la lista de verificación, no porque las dos cifras coincidan.',
  'avce.page.registerEmpty': 'El registro de activos fijos está vacío para {year}. Eso no hace que el área sea «no relevante»: los controles de abajo siguen buscando compras importantes contabilizadas como gasto, asientos en las cuentas de activo fijo y activos de periodos anteriores. Si el área realmente no es relevante, se establece con una justificación en la evaluación de relevancia de la lista de verificación.',
});
